export const ADMIN_SIDEBAR_WIDTH = 280